export default __webpack_public_path__ + "static/media/WAS0140.34I-35524_-20673_0.710e0dec.jpg";